export default function YouTubeBridge() {
  return (
    <section className="py-12 bg-gradient-to-r from-[#dc2626] to-[#b91c1c] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,.05) 10px, rgba(255,255,255,.05) 20px)',
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
          <div className="flex-shrink-0">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-white/10 rounded-full flex items-center justify-center border-2 border-white/30">
              <i className="ri-youtube-line text-3xl md:text-4xl text-white"></i>
            </div>
          </div>
          
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-2xl md:text-3xl font-black text-white mb-3 tracking-tight">
              DID YOU MISS THE LATEST TAX DEFENSE Q&A?
            </h3>
            <p className="text-base md:text-lg text-white/90 leading-relaxed">
              Every quarter, Mark Kohler joins Matt Theriault to answer your specific tax and entity questions directly from the YouTube comments. If you have a complex situation that can't wait for the next episode, bypass the line and book a 1-on-1 strategy session with his team below.
            </p>
          </div>

          <div className="flex-shrink-0">
            <button
              onClick={() => {
                const calendarSection = document.getElementById('calendar');
                if (calendarSection) {
                  calendarSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white text-[#dc2626] px-6 py-3 rounded-lg font-bold text-sm md:text-base hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
            >
              BOOK NOW <i className="ri-arrow-down-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}